<template>
    <div class="modal-card" style="width: 800px; height: 800px">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="user"></b-icon>
                Ajout d'un salarié
            </p>
        </header>
        <section class="modal-card-body">

          <div class="columns">
            <div class="column">
              <b-field label="Personnel">
                <b-autocomplete
                    v-model="filterBox"
                    placeholder="Rechercher"
                    keep-first
                    :data="filteredDataObj"
                    field="name"
                    open-on-focus
                    @select="option => (payload.salarie = option.name)"
                >
                  <template slot-scope="props">
                    <div class="media-content">
                      <b>{{ props.option.name }}</b>
                      <br>
                      <small>
                        <em>{{ props.option.fonction }}</em> <br>
                      </small>
                      <b-progress
                          type="is-info"
                          :value="props.option.days"
                          :max="props.option.daystospend"
                          show-value
                      >
                        {{ (props.option.daystospend - props.option.days).toFixed(2) }} jours libres
                      </b-progress>
                    </div>
                  </template>

                </b-autocomplete>
              </b-field>

              <b-field label="Nombre de jours">
                <b-input type="number" min="0" step="0.5" v-model="payload.days">
                </b-input>
              </b-field>

              <b-field label="Tâche">
                <b-input
                    type="text"
                    v-model="payload.comment"
                    maxlength="90"
                >
                </b-input>
              </b-field>

              <b-field label="Coût jour spécifique">
                <b-input type="number" v-model="payload.customcost">
                </b-input>
              </b-field>
            </div>
            <div class="column">

              <!--
              <br>
              <b-field>
                <b-slider
                    v-model="months"
                    :min="1"
                    :max="12"
                    :step="1"
                    ticks
                    tooltip-always
                    @change="dateSlider()"
                >
                </b-slider>
              </b-field>
              -->

              <b-field label="Début de la tâche">
                <b-datepicker
                    v-model="payload.start"
                    show-week-number
                    locale="fr-FR"
                    placeholder="Sélectionner"
                    icon="calendar"
                    icon-right="pen"
                    icon-right-clickable
                    @icon-right-click="clearDate('start')"
                    trap-focus>
                </b-datepicker>
              </b-field>

              <b-field label="Fin de la tâche">
                <b-datepicker
                    v-model="payload.end"
                    show-week-number
                    locale="fr-FR"
                    placeholder="Sélectionner"
                    icon="calendar"
                    icon-right="pen"
                    icon-right-clickable
                    @icon-right-click="clearDate('end')"
                    trap-focus>
                </b-datepicker>
              </b-field>

            </div>
          </div>

        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="addTodo">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "TodoAddModal",
        props: {
            salariesFree: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                payload: {
                  start: new Date(2026, 0, 1),
                  end: new Date(2027, 0, 1)
                },
                // AutoFilter
                filterBox: '',
                // Date scale
                months: [1, 12],
            };
        },
        computed: {
            filteredDataObj() {
                return this.salariesFree.filter(option => {
                    return (
                        option.name
                            .toString()
                            .toLowerCase()
                            .indexOf(this.filterBox.toLowerCase()) >= 0
                    )
                })
            }
        },
        methods: {
            /*
            getPoste(s) {
                const p = this.salariesFree.filter(md => s === md.name)
                return p[0].fonction;
            },
           */
          dateSlider() {
            let startMonth = this.months[0]-1;
            let endMonth = this.months[1]-1;
            const lastDay = new Date(2026, endMonth + 1, 0).getDate();
            this.payload.start = new Date(2026, startMonth, 1);
            this.payload.end = new Date(2026, endMonth, lastDay);
          },
          clearDate(d) {
              if (d === 'start') {
                console.log("clear")
                this.payload.start = null;
              } else {
                this.payload.end = null;
              }
            },
            addTodo() {
                if ( this.payload.salarie !== undefined
                    && this.payload.days !== undefined
                    && parseFloat(this.payload.days) >= 0
                    && this.checkStringChar(this.payload.comment)) {
                    this.payload.days = Math.round(this.payload.days * 2)/2
                    this.$emit("add-todo", this.payload);
                } else {
                    this.$buefy.snackbar.open(
                        {
                            message: `Personnel ou nombre de jours non-sélectionnés, ou caractères non autorisés`,
                            type: 'is-danger',
                            position: 'is-bottom-left'
                        });
                }
            }
        }
    };
</script>

<style scoped></style>
